import axios from 'axios';

export default {
  fetchClientList({
    commit,
  }, paginationParams) {
    commit('setLoading', true);
    commit('setError', false);

    return axios.get('/client', {
      params: paginationParams,
    })
      .then((companies) => {
        commit('setData', companies);
      })
      .catch((err) => {
        commit('setError', err);
      })
      .finally(() => {
        commit('setLoading', false);
      });
  },
};
